import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_REQUEST = `${PhotoCapture.PHOTO_CAPTURE}_INTELLIGENT_IMAGE_DETAILS_REQUEST`;
export const PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_SUCCESS = `${PhotoCapture.PHOTO_CAPTURE}_INTELLIGENT_IMAGE_DETAILS_SUCCESS`;
export const PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_FAILURE = `${PhotoCapture.PHOTO_CAPTURE}_INTELLIGENT_IMAGE_DETAILS_FAILURE`;
export const PHOTO_CAPTURE_INTELLIGENT_RESET_IMAGE_ANALYZER_DETAILS = `${PhotoCapture.PHOTO_CAPTURE}_INTELLIGENT_RESET_IMAGE_ANALYZER_DETAILS`;
export const photoCaptureIntelligentImageDetailsRequestAction = (request) => ({
    type: PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_REQUEST,
    payload: request
});
export const photoCaptureIntelligentImageDetailsSuccessAction = (photoCaptureImageData) => ({
    type: PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_SUCCESS,
    payload: { photoCaptureImageData }
});
export const photoCaptureIntelligentImageDetailsFailureAction = failureMessage => ({
    type: PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_FAILURE,
    payload: { failureMessage }
});
export const photoCaptureIntelligentResetImageAnalyzerDetailsAction = shouldDisplayParameter => ({
    type: PHOTO_CAPTURE_INTELLIGENT_RESET_IMAGE_ANALYZER_DETAILS,
    payload: { shouldDisplayParameter }
});
//# sourceMappingURL=photoCaptureIntelligentImageDetailsAction.js.map